<script>
  export default {
    name: 'list-yes-no',
    props: ['value']
  }
</script>

<template>
    <div>
        <el-tag v-if="value" type="primary">SIM</el-tag>
        <el-tag v-if="!value" type="danger">NÃO</el-tag>
    </div>
</template>



// WEBPACK FOOTER //
// YesNo.vue?67319c0a